import { getCategoriesForMenuForState } from 'shared/helpers/products';

export type TabsData = {
  label: string;
  key: string;
  icon?: string;
  visible?: boolean;
};

type GetTabsProps = {
  isEnabledAgeVerification: boolean;
  isSuperAdminUser: boolean;
};

export function getSelectedTab(currentTab: string, tabs: TabsData[]): string {
  return tabs.map((t) => t.key).some((t) => t === currentTab) ? currentTab : tabs[0].key;
}

export function getTabs({ isEnabledAgeVerification, isSuperAdminUser }: GetTabsProps): TabsData[] {
  const tabs: TabsData[] = [
    {
      label: 'Homepage',
      key: 'homepage',
    },
    {
      label: 'Theme',
      key: 'theme',
    },
    {
      label: 'Fonts',
      key: 'fonts',
    },
    {
      label: 'Product Cards',
      key: 'product-cards',
    },
    {
      label: 'Image Banner',
      key: 'image-banner',
    },
    {
      label: 'Text Banner',
      key: 'menu-banner',
    },
    {
      label: 'Categories',
      key: 'categories',
    },
    {
      label: 'Extensions',
      key: 'extensions',
      visible: isSuperAdminUser,
    },
    {
      label: 'Age Verification',
      key: 'age-verification',
      visible: isEnabledAgeVerification,
    },
    {
      label: 'Legal Disclaimer',
      key: 'legal-disclaimer',
    },
    {
      label: 'Embed',
      key: 'embed',
    },
  ];

  return tabs.filter((tab) => tab.visible !== false);
}

export function getCategoryLabels(state?: string | null): Record<string, string> | null {
  if (!state) {
    return null;
  }
  return getCategoriesForMenuForState(state).reduce<Record<string, string>>((acc, category) => {
    acc[category.value] = category.label;
    return acc;
  }, {});
}

export function getPathSegment(path: string, index: number): string {
  return path.split('/').slice(index)[0];
}
